import template from './nav/template.html';
import controller from './nav';

const usersSelfStudyState = {
  url: '/selfstudy',
  stateName: 'Classroom',
  data: {
    specialClass: 'fixed-sidebar gray-bg'
  },
  // abstract: true,
  views: {
    'root@': {
      template,
      controller,
      controllerAs: 'selfStudyCtrl'
    }
  }
};

const usersSelfStudyVideoState = {
  url: '/modules/:moduleId/video',
  stateName: 'Video',
  data: {
    specialClass: 'fixed-sidebar gray-bg'
  },
  views: {
    a: {
      template: '<self-study-video></self-study-video>'
    }
  }
};

const usersSelfStudyQuizState = {
  url: '/modules/:moduleId/quiz',
  stateName: 'Quiz',
  data: {
    specialClass: 'fixed-sidebar gray-bg'
  },
  views: {
    a: {
      template: '<self-study-quiz></self-study-quiz>'
    }
  }
};

const usersSelfStudyFinalState = {
  url: '/final',
  stateName: 'Classroom',
  data: {
    specialClass: 'fixed-sidebar gray-bg'
  },
  views: {
    a: {
      template: '<self-study-final></self-study-final>'
    }
  }
};

export { usersSelfStudyState, usersSelfStudyVideoState, usersSelfStudyQuizState, usersSelfStudyFinalState };



// WEBPACK FOOTER //
// ./src/app/controllers/users/selfStudy/index.js